<template>
  <div id="stream">
    <TPlayer id="player" />
    <iframe
      src="https://www.twitch.tv/embed/niller2005/chat?darkpopout"
      width="100%"
      height="100%"
      frameborder="0"
      scrolling="no"
      marginheight="0"
      marginwidth="0"
      id="chat"
    ></iframe>
  </div>
</template>

<script>
import TPlayer from '../components/TwitchPlayer.vue';
export default {
  name: 'Stream',
  components: {
    TPlayer
  }
};
</script>

<style lang="scss">
#stream,
#player {
  height: 100%;
}
#stream {
  display: grid;
  overflow: hidden;
  grid-template-columns: 4fr minmax(300px, 1fr);
  margin: 0;
  padding: 0;
}
</style>
